import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { TestCarPageService } from '@pages/test-car-page/test-car-page.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TestCarPageInterface } from '../adapter/test-car-page-adapter';

@Injectable({
  providedIn: 'root',
})
export class TestCarPageResolver implements Resolve<Observable<TestCarPageInterface | null>> {
  constructor(private testCarPageService: TestCarPageService, private router: Router, private appService: AppService) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<TestCarPageInterface | null> {
    const testCarSectionId = route.paramMap.get('testCarSectionId');
    this.appService.lightBackgroundPage();

    return this.testCarPageService.getTestCarPage(testCarSectionId).pipe(
      map((result) => {
        if (!result) {
          this.router.navigate(['404'], { skipLocationChange: true });
          return null;
        } else {
          return result;
        }
      })
    );
  }
}
